/* =============================================================================
   ATD - Carrusel de logos (atd-scrolling-logos1)
   Pausa suave al pasar el cursor: ramps playbackRate de la animación CSS
   entre 1 (velocidad normal) y 0 (detenido) con easing cubic-out.
   Usa Web Animations API estándar — sin dependencias.
   ============================================================================= */

(() => {
  const SECTION_SEL = '.atd-scrolling-logos1--pause-hover';
  const TRACK_SEL = '.atd-scrolling-logos1__track';
  const RAMP_MS = 600;
  const easeOut = (t) => 1 - Math.pow(1 - t, 3);

  function rampTo(state, target) {
    cancelAnimationFrame(state.frameId);
    const from = state.animation.playbackRate;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / RAMP_MS);
      state.animation.playbackRate = from + (target - from) * easeOut(t);
      if (t < 1) {
        state.frameId = requestAnimationFrame(tick);
      }
    };
    state.frameId = requestAnimationFrame(tick);
  }

  function setup(section, attempt = 0) {
    if (section.dataset.atdScrollingLogosInit === '1') return;

    const track = section.querySelector(TRACK_SEL);
    if (!track) return;

    const animation = track.getAnimations()[0];
    if (!animation) {
      // La animación CSS aún no ha arrancado (carga inicial).
      // Reintenta hasta 20 frames antes de rendirse.
      if (attempt < 20) {
        requestAnimationFrame(() => setup(section, attempt + 1));
      }
      return;
    }

    section.dataset.atdScrollingLogosInit = '1';
    const state = { animation, frameId: 0 };

    section.addEventListener('mouseenter', () => rampTo(state, 0));
    section.addEventListener('mouseleave', () => rampTo(state, 1));
    // Para usuarios con teclado/táctil: pausa al focus dentro de la sección.
    section.addEventListener('focusin', () => rampTo(state, 0));
    section.addEventListener('focusout', () => rampTo(state, 1));
  }

  function initAll(root = document) {
    const nodes = root.querySelectorAll
      ? root.querySelectorAll(SECTION_SEL)
      : [];
    nodes.forEach((node) => setup(node));
    // Si el root es la sección misma (caso shopify:section:load), incluirlo.
    if (root.matches && root.matches(SECTION_SEL)) {
      setup(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Cuando el theme editor recarga la sección, reinicializar.
  document.addEventListener('shopify:section:load', (e) => {
    initAll(e.target);
  });
})();
